export const SET_FULLSCREEN = 'map/SET_FULLSCREEN';